// @ts-nocheck
import type { CSSProperties } from 'react';

export const shadows = {
  card: {
    boxShadow: '0 0 4px rgba(33, 33, 33, 0.26)',
  } as CSSProperties,
};
